import request from "../utils/request";

export const listProduct = (search, route) => {
  return request({
    endpoint: `products/${route}?search=${search}`
  });
};
